export default function SubscribeCta() {
  return (
    <section className="w-full px-4 md:px-8 pb-16 md:pb-24">
      <div className="relative rounded-lg overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20editorial%20sound%20wave%20landscape%2C%20warm%20terracotta%20amber%20and%20deep%20teal%20tones%2C%20matte%20grain%20texture%2C%20minimal%20horizontal%20composition%2C%20no%20text&width=1600&height=700&seq=speak-cta-01&orientation=landscape"
            alt="黑料吃话语音原声内容更新"
            title="黑料吃话语音 - 更新提醒"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/40"></div>
        </div>

        <div className="relative w-full px-6 md:px-12 py-12 md:py-16">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-xs font-label text-background-100">
              <i className="ri-notification-3-line text-accent-400 text-sm"></i>
              更新提醒
            </span>
            <h2 className="mt-5 font-heading font-bold text-background-50 text-2xl md:text-4xl leading-snug tracking-tight">
              新录音整理好，
              <br className="hidden sm:block" />
              想第一时间听到吗
            </h2>
            <p className="mt-4 text-sm font-label text-background-200 leading-relaxed">
              事件更新、缺失片段补录、时间线修订，都会在这里同步。先收藏，回头再来听。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#hot"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-headphone-line text-lg"></i>
                立即去听热榜
              </a>
              <a
                href="#top"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-50/25 text-background-50 text-sm font-label hover:bg-background-50/20 transition-colors cursor-pointer"
              >
                <i className="ri-bookmark-line text-lg"></i>
                收藏本页
              </a>
            </div>

            <p className="mt-4 text-[11px] font-label text-background-300">
              页面为内容展示入口，收藏后随时回来查看最新整理。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}